import { Component } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'mwo-duplicate-day-page',
  templateUrl: './duplicate-day-page.component.html',
  styleUrls: ['./duplicate-day-page.component.scss']
})
export class DuplicateDayPageComponent {

  constructor(private router: Router) {
  }
  back() {
    this.router.navigate(['scheduler-modifier'])
  }
}
